import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import Button from "./../../components/v6/Button";

const Step3 = ({ item, handleClose }) => {
  const redeemedQuantity = item?.reward?.redemptions?.[0]?.quantity ?? 3;
  const newQuantity = Math.max(0, item.total_available - redeemedQuantity);

  const [displayQuantity, setDisplayQuantity] = useState(item.total_available);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (newQuantity !== item.total_available) {
        setDisplayQuantity(newQuantity);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [item.total_available, newQuantity]);

  return (
    <motion.div
      key="step3"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="flex flex-col items-center gap-6"
    >
      <h2 className="text-base font-bold text-center text-primary">
        Redeemed!
      </h2>

      <div
        className="flex size-[60px] items-center justify-center rounded-full shadow-badge relative"
        style={{ background: item.background || "#ECEEFF" }}
      >
        {item.isNew && (
          <p className="bg-destructive text-white py-[1px] px-[6px] text-[9px] font-bold rounded-xl absolute top-[-10px] left-1/2 -translate-x-1/2">
            New
          </p>
        )}

        <AnimatePresence mode="wait">
          <motion.p
            key={displayQuantity}
            initial={{ scale: 0.8, y: 10, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.8, y: -10, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            className="bg-primary text-white py-[1px] px-1.5 text-[10px] font-bold rounded-xl absolute bottom-0 right-[-4px] min-w-[18px] text-center"
          >
            {displayQuantity}
          </motion.p>
        </AnimatePresence>

        <div className="rounded-full size-[60px] overflow-hidden">
          <img
            className="size-full object-cover rounded-full"
            src={
              item?.image_data
                ? `${process.env.REACT_APP_URL_IMAGE}/${item?.image_data?.file_path}`
                : "/images/brand.jpg"
            }
            alt=""
          />
        </div>
      </div>

      <p className="text-center text-2xl leading-none font-bold text-primary">
        -{redeemedQuantity} {redeemedQuantity > 1 ? "stickers" : "sticker"}
      </p>
      <p className="text-dark-gray text-lg text-center leading-none">
        You have {displayQuantity} {item?.name} sticker left.
      </p>

      <Button handleClick={handleClose} className="w-full">
        Done
      </Button>
    </motion.div>
  );
};

export default Step3;
